module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center info-hotsite"
  }, [_vm._v("\n    Foi enviado um e-mail para "), _c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(", confirme seu e-mail para prosseguir com o pedido.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0991f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotsite/Confirm.vue
// module id = 770
// module chunks = 40